class LocationMap {
    constructor(element) {
        this.element = element;
        this.locations = locationMapData.locations;
        this.settings = locationMapData.settings;
        this.map = null;
        this.infoWindow = null;
        this.markers = [];
    }

    init() {
        this.createMap();
        this.createInfoWindow();
        this.addMarkers();
    }

    createMap() {
        this.map = new google.maps.Map(this.element, {
            zoom: this.settings.zoom,
            center: this.settings.center,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
    }

    createInfoWindow() {
        this.infoWindow = new google.maps.InfoWindow();
    }

    addMarkers() {
        this.locations.forEach((location) => {
            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(location.lat, location.lon),
                map: this.map,
                icon: {
                    url: location.color
                }
            });

            this.markers.push(marker);
            this.addMarkerClickListener(marker, location);
        });
    }

    addMarkerClickListener(marker, location) {
        marker.addListener('click', () => {
            const content = `
                ${location.name}
                ${location.hours}
                ${location.amenities}
            `;
            this.infoWindow.setContent(content);
            this.infoWindow.open(this.map, marker);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const mapElements = document.querySelectorAll('[data-map]');
    mapElements.forEach(element => {
        const map = new LocationMap(element);
        map.init();
    });
});


export default LocationMap;
